export default {
      id: "icon-notice-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "icons.svg#icon-notice",
      toString: function () {
        return this.url;
      }
    }